import i18n from '@/i18n'

const Meta = {
  leftMenuCode: 'Configurations',
  leftActiveIndex: '/groups'
}

export default [
  {
    path: '/groups',
    meta: {
      ...Meta,
      title: i18n.t('menu.domainGroupMngmt')
    },
    component: () => import('@/views/groups/index.vue')
  },
  {
    path: '/groups/add',
    meta: {
      ...Meta,
      title: i18n.t('groups.addDomainGroup'),
      backable: true
    },
    component: () => import('@/views/groups/add.vue')
  },
  {
    path: '/groups/edit',
    meta: {
      ...Meta,
      title: i18n.t('groups.editDomainGroup'),
      backable: true
    },
    component: () => import('@/views/groups/add.vue')
  }
]
